import { computed, ref, ComputedRef, Ref, getCurrentInstance, ComponentInternalInstance } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';

// 引入工具类
import tips from '@/renderer/scripts/utils/tips';
import smh from '@/renderer/scripts/smh';
import { getChannel } from '@/renderer/scripts/composition/channel';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import user, { User } from '@/renderer/scripts/utils/user';

type GetSMSParams = {
  countryCode: string;
  phoneNumber: string;
  flag?: string | number;
  type: string;
  captchaTicket?: string;
  captchaRandstr?: string;
  collectToken?: string;
};
type Handler = {
  isCounting: Ref<boolean>;
  smsText: ComputedRef<string>;
  getSMS: ({ countryCode, phoneNumber, type, captchaTicket, captchaRandstr, collectToken }: GetSMSParams) => Promise<{
    error: null | {};
  }>;
  getIndexPage: () => string;
  resetSeconds: () => void;
};
export default function actionHandler(isVistor?: Ref<boolean>): Handler {
  const vm = (getCurrentInstance() as ComponentInternalInstance).proxy;
  // 验证码相关
  let timer: number | undefined;
  const SECOND_COUNT = 60;
  const seconds = ref(SECOND_COUNT);
  const isCounting = ref(false);
  const smsText = computed(() =>
    isCounting.value
      ? i18n_t('{slot1}S后重发', {
          slot1: seconds.value,
        })
      : i18n_t('获取验证码'),
  );
  const methods = {
    // 验证码按钮倒计时
    startCountSeconds() {
      isCounting.value = true;
      timer = window.setInterval(() => {
        if (seconds.value === 0) {
          methods.resetSeconds();
          return;
        }
        seconds.value--;
      }, 1000);
    },
    // 重置倒计时
    resetSeconds() {
      if (timer) {
        window.clearInterval(timer);
        timer = undefined;
      }
      isCounting.value = false;
      seconds.value = SECOND_COUNT;
    },
    // 发送验证码
    async getSMS({
      countryCode = '',
      phoneNumber = '',
      type = 'sign-in',
      captchaTicket = '',
      captchaRandstr = '',
      collectToken = '',
    }) {
      const result = {
        error: null,
      };
      const { isPrivate } = vm.$store.getters;
      const { code: inviteCode } = vm.$route.params;
      // 发送验证码如果是立即加入才传邀请码
      const { loginFunc } = user.getUserInfoSync();
      const { channelTag } = getChannel(isVistor?.value);
      try {
        await smh.api.sendSMS({
          countryCode,
          phoneNumber,
          flag: !isPrivate ? 1 : '',
          type,
          ...(!isPrivate && {
            domain: CONSTANT_URL.currentDomain,
          }),
          captchaTicket,
          captchaRandstr,
          ...(loginFunc === User.LoginFuncKey.loginToJoin && {
            inviteCode,
          }),
          ...(channelTag && {
            pf: channelTag,
          }),
          ...(collectToken && {
            collectToken,
          }),
        });
        tips.success(i18n_t('验证码发送成功'));
        methods.startCountSeconds();
      } catch (e: any) {
        result.error = e;
        // tips.error(e as MsgError);
      }

      return result;
    },
    // 获取登录主页
    getIndexPage() {
      const routerName = vm.$store.getters.isMobileStyle ? 'recentUse' : 'workbench';
      return routerName;
    },
  };
  return {
    isCounting,
    smsText,
    ...methods,
  };
}
